import React, { useState } from "react";
import { ImageOff } from "lucide-react";
import { mediaUrl } from "../lib/format";

export default function ProductImage({ src, alt, className = "", title }) {
  const [error, setError] = useState(false);
  const resolved = mediaUrl(src);
  if (!resolved || error) {
    return (
      <div
        className={`flex items-center justify-center bg-muted text-muted-foreground ${className}`}
        aria-label={alt}
      >
        <div className="flex flex-col items-center gap-1 opacity-60">
          <ImageOff className="h-6 w-6" />
          <span className="text-[10px] font-mono">FABRIPAN</span>
        </div>
      </div>
    );
  }
  return (
    <img
      src={resolved}
      alt={alt}
      title={title || alt}
      className={className}
      onError={() => setError(true)}
    />
  );
}
